export const MARKET_STAGE_LABEL_KEYS = {
  EXPLOSIVE_LIQUIDITY: 'vnstock.recommendations.marketStage.stageLabels.EXPLOSIVE_LIQUIDITY',
  HEALTHY_UPTREND: 'vnstock.recommendations.marketStage.stageLabels.HEALTHY_UPTREND',
  SIDEWAY_ACCUMULATION: 'vnstock.recommendations.marketStage.stageLabels.SIDEWAY_ACCUMULATION',
  DRY_LIQUIDITY: 'vnstock.recommendations.marketStage.stageLabels.DRY_LIQUIDITY',
  DISTRIBUTION: 'vnstock.recommendations.marketStage.stageLabels.DISTRIBUTION',
  RISK_OFF: 'vnstock.recommendations.marketStage.stageLabels.RISK_OFF',
};

export const MARKET_PLAYBOOK_LABEL_KEYS = {
  AGGRESSIVE_GROWTH: 'vnstock.recommendations.marketStage.playbookLabels.AGGRESSIVE_GROWTH',
  TREND_FOLLOWING: 'vnstock.recommendations.marketStage.playbookLabels.TREND_FOLLOWING',
  ACCUMULATION_HUNTER: 'vnstock.recommendations.marketStage.playbookLabels.ACCUMULATION_HUNTER',
  SPECIAL_SITUATION: 'vnstock.recommendations.marketStage.playbookLabels.SPECIAL_SITUATION',
  CAPITAL_DEFENSE: 'vnstock.recommendations.marketStage.playbookLabels.CAPITAL_DEFENSE',
};

export const getMarketStageLabel = (t, stage) => {
  if (!stage) return '';
  return t(MARKET_STAGE_LABEL_KEYS[stage] || stage, stage);
};

export const getMarketPlaybookLabel = (t, playbook) => {
  if (!playbook) return '';
  return t(MARKET_PLAYBOOK_LABEL_KEYS[playbook] || playbook, playbook);
};
